<template>
  <div class="dialog-table-input">
    <PgInput
      class="dialog-table-input__btn"
      :clearable="clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
    />
    <Button type="text" @click="visible = true">{{ text }}</Button>
    <PgDialogTable
      v-bind="$attrs"
      :placeholder="placeholder"
      :visible.sync="visible"
      :isSelection="false"
      @row-change="rowChange"
    />
  </div>
</template>
<script setup>
import { PgInput } from '../../input/index'
import { Button } from 'element-ui'
import PgDialogTable from './dialog-table.vue'
import { getValueByPath } from '../../../utils/index'
import { ref } from 'vue'

const props = defineProps({
  text: {
    type: String,
    default: '参考',
  },
  value: String,
  selectKey: {
    type: String,
    default: 'name',
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  disabled: Boolean,
  placeholder: String,
  seachPlaceholder: String,
})

const emit = defineEmits(['input'])

const visible = ref(false)
const rowChange = ({ row }) => {
  emit('input', getValueByPath(row, props.selectKey))
  visible.value = false
}

const onInput = (val) => {
  emit('input', val)
}
</script>
<style lang="scss">
@import '../style/dialog-table-input.scss';
</style>
